import { CpDocumentRequestInterface } from '../../../interfaces/request/document/cp-document-request-interface';

export class CpDocumentRequestModel implements CpDocumentRequestInterface {
  DocumentType: string = '';
  EndDate: string = '';
  Page: number = 1;
  PageSize: number = 5;
  StartDate: string = '';

  constructor(init?: Partial<CpDocumentRequestModel>) {
    Object.assign(this, init);
  }
}
